import apm from '@control-front-end/common/apm';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Utils } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import TabNotify from '@control-front-end/utils/tabNotify';
import api from '@control-front-end/common/sagas/api';
import {
  APP_AUTH_KEY,
  APP_AUTH_START,
  SET_TAB_ID,
  AUTH,
  LOGOUT,
  ACCOUNTS,
  CHECK_SESSION,
  CHECK_VERSION,
  WS_OPEN,
  RequestStatus,
} from 'constants';
import { GRAPH_REALTIME_PROLONGATION } from '@control-front-end/common/constants/graphRealtime';

/**
 * Получить идентификатор вкладки браузера
 */
function getTabId() {
  const tabId = Utils.fromSessionStorage('controlTabId');
  if (tabId) return tabId;
  const newTabId = AppUtils.udid();
  Utils.toSessionStorage('controlTabId', newTabId);
  return newTabId;
}

/**
 * Авторизация приложения
 */
function* authApp() {
  yield put({ type: SET_TAB_ID.SUCCESS, payload: getTabId() });
  const appAuthStr = Utils.fromStorage(APP_AUTH_KEY) || '{}';
  const appAuth = JSON.parse(appAuthStr);
  const { udid, token } = appAuth;
  // Получаем информацию о пользователе
  if (token) {
    yield put({ type: APP_AUTH_START.SUCCESS, payload: appAuth });
    yield put({ type: AUTH.REQUEST });
    yield put({ type: CHECK_SESSION });
    yield put({ type: CHECK_VERSION });
    yield put({ type: GRAPH_REALTIME_PROLONGATION });
    return;
  }

  // Получение токена
  const nUdid = udid || AppUtils.udid();
  Utils.toStorage(APP_AUTH_KEY, JSON.stringify({ udid: nUdid }));
  yield put({ type: APP_AUTH_START.SUCCESS, payload: { udid: nUdid } });
  const { result, data } = yield call(api, {
    method: 'get',
    url: '/auth/start',
  });
  if (result !== RequestStatus.SUCCESS) return;

  if (data && data.action === 'auth') {
    Utils.toStorage(APP_AUTH_KEY, JSON.stringify(data.data));
    yield put({ type: APP_AUTH_START.SUCCESS, payload: data.data });
    yield put({ type: AUTH.REQUEST });
    yield put({ type: CHECK_SESSION });
    yield put({ type: CHECK_VERSION });
    yield put({ type: GRAPH_REALTIME_PROLONGATION });
  } else {
    if (document.location.pathname.indexOf('error') !== -1) return;
    const queryParams = Utils.getQueryParam(location.search);
    const returnUrl =
      queryParams.returnUrl || encodeURIComponent(document.location.href);
    document.location.href = `${data.data}&returnUrl=${returnUrl}`;
  }
}

/**
 * Авторизация пользователя
 */
function* authMe() {
  const { result, data } = yield call(api, {
    method: 'get',
    url: '/auth/me',
  });
  if (result === 'unauth') {
    Utils.delStorage(APP_AUTH_KEY);
    document.location.reload();
    return;
  }
  if (result !== RequestStatus.SUCCESS) {
    document.location.href = '/static/blocked.html';
    return;
  }
  yield put({ type: ACCOUNTS.REQUEST });
  const config = yield select((state) => state.config);
  data.data.avatar = config.avatarPath.replace('{userId}', data.data.id);
  yield put({ type: AUTH.SUCCESS, payload: data.data });
  yield put({ type: WS_OPEN });
  // Установить контекст для ошибок в apm
  apm.setUserContext({
    id: data.data.id,
    username: data.data.nick,
  });
  // Слушаем изменения title таба
  TabNotify.listenTabFocus();
  TabNotify.requestNotifyPopup();
}

/**
 * Деавторизировать пользователя
 */
function* logout({ payload }) {
  const toRoot = payload ? payload.toRoot : false;
  const { result, data } = yield call(api, {
    method: 'get',
    url: '/auth/logout',
  });
  if (result !== RequestStatus.SUCCESS) return;
  Utils.delStorage(APP_AUTH_KEY);
  const returnUrl = toRoot
    ? encodeURIComponent(
        `${document.location.protocol}//${document.location.host}`
      )
    : encodeURIComponent(document.location.href);
  document.location.href = `${data.data}?redirect_uri=${returnUrl}`;
}

function* auth() {
  yield takeLatest(APP_AUTH_START.REQUEST, authApp);
  yield takeLatest(AUTH.REQUEST, authMe);
  yield takeLatest(LOGOUT.REQUEST, logout);
}

export default auth;
